import * as React from "react";

const InputCalendarInactive: React.FC = () => (
    <svg
        width="14px"
        height="16px"
        viewBox="0 0 14 16"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill="currentColor"
            d="M4.75,0.75 L4.75,0 L3.25,0 L3.25,0.75 L3.25,2 L0,2 L0,4.5 L0,6 L0,14.5 L0,16 L1.5,16 L12.5,16 L14,16 L14,14.5 L14,6 L14,4.5 L14,2 L10.75,2 L10.75,0.75 L10.75,0 L9.25,0 L9.25,0.75 L9.25,2 L4.75,2 L4.75,0.75 Z M1.5,6 L12.5,6 L12.5,14.5 L1.5,14.5 L1.5,6 Z"
        />
    </svg>
);

export default React.memo(InputCalendarInactive);
